
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { FileText } from 'lucide-react';

export const ComplianceQuickActions = () => {
  return (
    <Card className="border-gray-100">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg text-gray-700">Quick Actions</CardTitle>
        <CardDescription className="text-gray-500">
          Frequently used compliance tools
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col items-center justify-center h-[200px] text-center">
        <FileText className="h-10 w-10 text-gray-300" />
        <p className="mt-4 text-sm text-gray-500">Coming soon: Quick Actions</p>
      </CardContent>
    </Card>
  );
};
